import renderMustache from './render-mustache';

export default class AbstractComponent {
    constructor(container, props) {
        this.state = {};
        this.props = props || {};
        this.container = container || null;
        this.component = null;
        this.renderMethod = 'innerHTML';
    }

    setState(newState = {}) {
        // Only set if newState is an object
        this.state = newState;
        this.render();
    }

    render() {
        renderMustache(this.container, this.renderMethod, this.template, this.state);
    }
}
